import { Link } from "../lib/router";
import { useLanguage } from "../i18n/LanguageContext";
import { LogoFull } from "./Logo";

const CONTACT_EMAIL = "office@pilateson.de";

export const Footer = () => {
  const { t } = useLanguage();

  const menu = [
    ["/", t.nav.home],
    ["/reformer", t.nav.reformer],
    ["/equipment", t.nav.equipment],
    ["/fuer-studios", t.nav.studios],
    ["/ueber-uns", t.nav.about],
    ["/kontakt", t.nav.contact],
  ];
  const legal = [
    ["/impressum", t.footer.legal.impressum, "footer-impressum"],
    ["/datenschutz", t.footer.legal.datenschutz, "footer-datenschutz"],
    ["/agb", t.footer.legal.agb, "footer-agb"],
    ["/widerruf", t.footer.legal.widerruf, "footer-widerruf"],
  ];

  return (
    <footer data-testid="footer" className="bg-[#1C1C1A] text-[#FAF8F5]">
      <div className="mx-auto max-w-[1400px] px-6 pt-24 pb-16 md:px-12 lg:px-20">
        <div className="mb-16">
          <LogoFull className="h-14 w-auto md:h-16" variant="light" />
          <span data-testid="footer-claim" className="sr-only">PILATES ON. WORLD OFF.</span>
        </div>

        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <p className="font-serif text-3xl font-light italic leading-snug text-[#FAF8F5]/80">
              {t.footer.tagline}
            </p>
          </div>

          <nav aria-label="Footer">
            <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.3em] text-[#C5A059]">
              {t.footer.menuCol}
            </p>
            <ul className="space-y-3">
              {menu.map(([to, label]) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-sm text-[#FAF8F5]/60 transition-colors duration-300 hover:text-[#FAF8F5]"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Legal">
            <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.3em] text-[#C5A059]">
              {t.footer.legalCol}
            </p>
            <ul className="space-y-3">
              {legal.map(([to, label, id]) => (
                <li key={to}>
                  <Link
                    to={to}
                    data-testid={id}
                    className="text-sm text-[#FAF8F5]/60 transition-colors duration-300 hover:text-[#FAF8F5]"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.3em] text-[#C5A059]">
              {t.footer.contactCol}
            </p>
            <ul className="space-y-3 text-sm text-[#FAF8F5]/60">
              <li data-testid="footer-email"><a href={`mailto:${CONTACT_EMAIL}`} className="transition-colors duration-300 hover:text-[#C5A059]">{CONTACT_EMAIL}</a></li>
              <li data-testid="footer-address" className="whitespace-pre-line">{t.contact.addressValue}</li>
            </ul>
          </div>
        </div>

        <p className="mt-16 font-mono text-[10px] uppercase tracking-[0.18em] text-[#FAF8F5]/35">
          {t.footer.note}
        </p>
      </div>

      <div className="border-t border-[#FAF8F5]/10">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-6 font-mono text-[10px] uppercase tracking-[0.18em] text-[#FAF8F5]/45 md:px-12 lg:px-20">
          <span>{t.footer.rights}</span>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="transition-colors duration-300 hover:text-[#C5A059]"
          >
            {t.footer.admin}
          </Link>
        </div>
      </div>
    </footer>
  );
};
